import { render, staticRenderFns } from "./filial-segmentation.vue?vue&type=template&id=10cb92f8&"
import script from "./filial-segmentation.vue?vue&type=script&lang=js&"
export * from "./filial-segmentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cb92f8')) {
      api.createRecord('10cb92f8', component.options)
    } else {
      api.reload('10cb92f8', component.options)
    }
    module.hot.accept("./filial-segmentation.vue?vue&type=template&id=10cb92f8&", function () {
      api.rerender('10cb92f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/filial-segmentation.vue"
export default component.exports